import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import TableView from '../Common/TableView';

import { MessageDialogs, ModuleDialogs } from '../../constants/Dialogs';
import BulkEmailDialog from '../Message/BulkEmailDialog';
import ModuleEventAttendanceTableRow from './ModuleEventAttendanceTableRow';
import ModuleEventScoreDialog from './ModuleEventAttendeeDialog';

import IconButton from 'material-ui/IconButton';
import EmailIcon from 'material-ui/svg-icons/communication/email';
import InfoIcon from 'material-ui/svg-icons/action/info';
import SignOutIcon from 'material-ui/svg-icons/navigation/cancel';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleEventStore from '../../stores/ModuleEventStore';
import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import { sendBulkEmail } from '../../actions/MessageActionCreator';
import buildContextMenu from '../Common/BuildContextMenu';
import { DateStyles } from '../../constants/CentricConstants';
import { FormattedDate, FormattedTime } from 'react-intl';

class ModuleEnrolments extends Component {

    componentDidMount() {
        this.onSaveEnrolment = this.onSaveEnrolment.bind(this);
        this.onRowSelection = this.onRowSelection.bind(this);
        this.openMessageDialog = this.openMessageDialog.bind(this);
        this.search = this.search.bind(this);

        ModuleActions.getEvent(this.state.moduleId, this.state.eventId);
        ModuleActions.getSubscriptions(this.state.moduleId, {eventId: this.state.eventId});
    }

    getDialog() {
        switch (this.state.dialog) {
            case MessageDialogs.BULK_EMAIL:
                return (
                    <BulkEmailDialog
                        onSave={({subject, message, users}) => sendBulkEmail(subject, message, users)}
                    />
                );
            case ModuleDialogs.MODULE_EVENT_SCORE:
                return (
                    <ModuleEventScoreDialog
                        onSave={this.onSaveEnrolment}
                    />
                );
            default: break;
        }
    }

    render() {

        const headers = [
            'Name',
            'Attendance',
            {label: 'Score', className: 'table-column-score', style: {width: '4em'} },
            ''
        ];

        const dialog = this.getDialog();
        const actions = buildContextMenu(this.getActions(), this.context.auth);
        let title = '';
        if (!!this.state.moduleEvent) {
            const start = new Date(this.state.moduleEvent.timeStart);
            title = <span>{this.state.moduleEvent.name}, <FormattedDate {...DateStyles.long} value={start} /> at <FormattedTime value={start} /></span>
        }

        return (
            <TableView
                title={title}
                headers={headers}
                rows={this.state.subscriptions}
                decorator={ModuleEventAttendanceTableRow}
                backButton={true}
                actions={actions}
                multiSelectable={true}
                enableSelectAll={true}
                onRowSelection={this.onRowSelection}
                tableActions={this.getTableActions()}
                searchAction={this.search}
            >
                {dialog}
            </TableView>
        );
    }

    getActions() {
        return [
            {
                link: `/dashboard/module/${this.state.moduleId}`,
                icon: <InfoIcon />,
                label: 'Preview',
            },
            {
                type: 'divider'
            },
            {
                link: '/logout',
                icon: <SignOutIcon />,
                label: 'Sign out',
            },
        ];
    }

    getTableActions() {
        return [
            <IconButton
                key="mass_email"
                tooltip="Send message"
                disabled={this.state.selected.length === 0}
                onClick={this.openMessageDialog}
            >
                <EmailIcon />
            </IconButton>
        ];
    }

    onSaveEnrolment(draft) {
        if (!draft.userId) { return false; } // userId is required
        const current = this.state.subscriptions.find((e) => (e !== undefined && e.moduleId === this.state.moduleId && e.userId === draft.userId), this);
        ModuleActions.saveSubscription(this.state.moduleId, draft.userId, draft, current);
    }

    onRowSelection(selected) {
        if (selected === this.state.selected) { return; } // guard
        this.setState({selected});
    }

    openMessageDialog() {
        if (this.state.selected.length === 0) { return; } // guard
        let users;
        if (this.state.selected === 'all') {
            users = this.state.subscriptions;
        } else {
            users = this.state.subscriptions.filter((user, i) => this.state.selected.includes(i));
        }
        users = users.map(({userId, title, firstName, lastName}) => ({id: userId, name: `${title || ""} ${firstName || ""} ${lastName || ""}`.trim()}));

        DialogActions.open(MessageDialogs.BULK_EMAIL, {users, subject: '', message: ''});
    }

    search(searchText) {
        this.timeout && clearTimeout(this.timeout);
        if (!!searchText && searchText.length > 2) {
            this.timeout = setTimeout(() => { ModuleActions.searchSubscriptions(this.state.moduleId, searchText, {eventId: this.state.eventId}); }, 500);
        }
    }
}

ModuleEnrolments.getStores = () => ([ModuleSubscriptionStore, ModuleEventStore, DialogStore]);
ModuleEnrolments.calculateState = (prevState, {routeParams}) => {
    const moduleId = (!!prevState && prevState.moduleId) || Number(routeParams.id);
    const eventId = (!!prevState && prevState.eventId) || Number(routeParams.eventId);
    return {
        moduleId,
        eventId,
        moduleEvent:    ModuleEventStore.getEvent(moduleId, eventId),
        selected:       (!!prevState && prevState.selected) || [],
        subscriptions:  ModuleSubscriptionStore.getByModuleEvent(moduleId, eventId),
        dialog:         DialogStore.getOpenDialog()
    };
};

ModuleEnrolments.contextTypes = {
    auth:   PropTypes.object.isRequired
};

export default Container.create(ModuleEnrolments, {withProps: true});
